<template>
  <div class="divView">
    <fieldset>
      <legend class="accessibleHide">View</legend>
      <a
        href="javascript: void 0"
        @click="clicked">
        <img
          v-if="view === 'Chart'"
          :id="'chartIcon_' + instance"
          src="./assets/chart-selected.png"
          alt="Chart is currently displayed"
        >
        <img
          v-else
          :id="'chartIcon_' + instance"
          src="./assets/chart-unselected.png"
          alt="Display chart"
        >
      </a>
      <a
        href="javascript: void 0"
        @click="clicked">
        <img
          v-if="view === 'Table'"
          :id="'tableIcon_' + instance"
          src="./assets/table-selected.png"
          alt="Table is currently displayed"
        >
        <img
          v-else
          :id="'tableIcon_' + instance"
          src="./assets/table-unselected.png"
          alt="Display table"
        >
      </a>
    </fieldset>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  // Note: button icons images are mananged as webpack module dependencies.
  // See http://vuejs-templates.github.io/webpack/static.html
  // for more info.
  name: 'ViewButtons',
  props: {
    instance: {
      type: Number,
      default: 0,
    },
    view: {
      type: String,
      default: 'Chart',
    },
  },
  methods: {
    clicked(evt) {
      // evt.target is the image if clicked via the mouse
      // or the anchor tag if selected via the enter key
      const id = evt.target.id || evt.target.getElementsByTagName('img')[0].id;
      let newView = this.view;
      // switch on the part before the '_'
      switch (_.split(id, '_')[0]) {
        case 'chartIcon':
          newView = 'Chart';
          break;
        case 'tableIcon':
          newView = 'Table';
          break;
        default:
          throw new Error(`Unexpected icon id: ${id}`);
      }
      if (newView !== this.view) {
        // this.$store.commit('SP/setView', newView);
        this.$emit('changeView', newView);
      }
    },
  },

};

</script>

<style scoped>
  .divView {
    font-size: 0;
    margin: 10px 10px;
  }

  .divView a {
    display: inline-block;
    height: 29px;
  }

  fieldset {
    border: 0;
    padding: 0.01em 0 0 0;
    margin: 0;
    min-width: 0;
    height: 29px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SP/SPViewButtons.vue